"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateValue = void 0;
class DateValue {
    dateString;
    constructor(dateString = '') {
        if (dateString == '') {
            const currentDate = new Date();
            let estDate;
            if (currentDate.toLocaleString) {
                estDate = currentDate.toLocaleString('en-US', { timeZone: 'America/New_York' }).split(',')[0].split('/');
                const dd = String('00' + estDate[1]).slice(-2);
                const mm = String('00' + (estDate[0])).slice(-2);
                const yyyy = estDate[2].slice(-4);
                this.dateString = yyyy + '-' + mm + '-' + dd;
            }
            else {
                this.dateString = this.dateToString(currentDate);
            }
        }
        else {
            this.dateString = dateString;
        }
    }
    dateToString(date) {
        return date.toISOString().slice(0, 10);
    }
    addDays(days) {
        const date = new Date(this.dateString);
        date.setDate(date.getDate() + days);
        this.dateString = this.dateToString(date);
    }
    addMonths(months) {
        const date = new Date(this.dateString);
        date.setMonth(date.getMonth() + months);
        this.dateString = this.dateToString(date);
    }
    addYears(years) {
        const date = new Date(this.dateString);
        date.setFullYear(date.getFullYear() + years);
        this.dateString = this.dateToString(date);
    }
    toString() {
        return this.dateString;
    }
    toMMDDYYYY() {
        var dd = this.dateString.slice(8, 11);
        var mm = this.dateString.slice(5, 7);
        var yyyy = this.dateString.slice(0, 4);
        return mm + '/' + dd + '/' + yyyy;
    }
    toEpoc() {
        const date = new Date(this.dateString);
        return Math.round(date.getTime() / 1000);
    }
}
exports.DateValue = DateValue;
